import { FC, useEffect, useState } from 'react';
import { Typography, Grid, IconButton, Tooltip, Checkbox } from '@mui/material';
import { useAppDispatch } from '../../../hooks';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { fetchLedgerSummaryPdf } from './Services';
import { showAlertAction } from '../../../store/alerts';
import { getLedgerSummaryDataAction } from './actions';
export const circleButtonSize = '32px'
export const circleIconSize = '18px'


const LedgerSummaryHeader: FC = () => {

  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isEnabled, setIsEnabled] = useState(true);

  const dispatchAction = useAppDispatch();
  const fetchPDF = (() => {
    setIsEnabled(false)
    fetchLedgerSummaryPdf().then(
      (response) => {
        setIsEnabled(true)
        if (response.success) {
          window.open(response.data, '_blank')
        } else {
          dispatchAction(
            showAlertAction({
              message: response.message,
              severity: 'error',
            })
          )
        }

      }
    )

  })
  useEffect(() => {
    if (isInitialLoad) {
      dispatchAction(getLedgerSummaryDataAction());
      setIsInitialLoad(false);
    }
  }, [isInitialLoad]);

  return (
    <>
      <Grid container alignItems="stretch">
        <Grid item md={5}>
          <Typography variant="h3" component="h3" gutterBottom pl={2.5}>
          Due Payments
          </Typography>
        
        </Grid>
      
        <Grid
          md={7}
          item
          sx={{ width: 250, textAlign: 'right', display: 'flex', justifyContent: 'right', alignItems: 'center' }}
        >
         
           <Tooltip title="Export PDF">
         <IconButton
           disabled={!isEnabled}
           onClick={() => {
             fetchPDF();
           }}
           sx={{
            mr:2,
             backgroundColor: '#1976d2',
             '&:hover': {
               backgroundColor: '#1565c0',
             },
             color: 'white',
             width: {circleButtonSize},
             height: {circleButtonSize},
             borderRadius: '50%', // Circular shape
             justifyContent: 'center',
             alignItems: 'center',
           }}
         >
           <PictureAsPdfIcon sx={{width:circleIconSize, height:circleIconSize}}/>
         </IconButton>
       </Tooltip>
         
        </Grid>
      </Grid>
    </>
  );
};

export default LedgerSummaryHeader;
